<template>
  <label
    class="sf-form-check"
    data-testid="sf-checkbox"
    :class="containerClass"
  >
    <slot name="left-side"> </slot>
    <input
      v-bind="attrs"
      :checked="value"
      type="checkbox"
      :disabled="disabled"
    />
    <span class="sf-form-check-content">
      <span class="sf-form-check-indicator" :class="indicatorClasses" />
    </span>
    <span v-if="label">{{ label }}</span>
    <slot name="right-side"> </slot>
  </label>
</template>
<script setup lang="ts">
import { computed, useAttrs } from 'vue'

import useModel from '@app/shared/vue/composables/use-model'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SfCheckbox',
  inheritAttrs: false,
})

interface Props {
  disabled?: boolean
  display?: 'inline' | 'block'
  label?: string
  modelValue?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  display: 'inline',
  label: '',
})

const emit =
  defineEmits<{
    'update:modelValue': [boolean]
  }>()

const containerClass = computed(() => ({
  'sf-inline-block': props.display === 'block',
  'sf-level': props.display === 'inline',
}))

const indicatorClasses = computed(() => ({
  'sf-disabled': props.disabled,
}))

const $attrs = useAttrs()

const attrs = computed(() => {
  return {
    ...$attrs,
    onChange: (event: Event) => {
      const target = event.target as HTMLInputElement
      emit('update:modelValue', target.checked)
    },
  }
})

const value = useModel(props, emit)
</script>
